import { CrosshairIcon, LinkedinIcon, TwitterIcon } from 'lucide-react'

import { Separator } from '@/components/ui/separator'

const Footer = () => {
  return (
    <footer>
      <div className='mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 max-md:flex-col sm:px-6 sm:py-6 md:gap-6 md:py-8'>
        <a href='/'>
          <div className='flex items-center gap-2.5'>
            <div className='bg-primary text-primary-foreground flex size-8 items-center justify-center rounded-md'>
              <CrosshairIcon className='size-5' />
            </div>
            <span className='text-lg font-semibold tracking-tight'>Prospect Hunter</span>
          </div>
        </a>

        <div className='flex items-center gap-5 whitespace-nowrap'>
          <a href='#features' className='opacity-80 transition-opacity duration-300 hover:opacity-100'>
            Features
          </a>
          <a href='#how-it-works' className='opacity-80 transition-opacity duration-300 hover:opacity-100'>
            How it works
          </a>
          <a href='#faq' className='opacity-80 transition-opacity duration-300 hover:opacity-100'>
            FAQ
          </a>
          <a href='#pricing' className='opacity-80 transition-opacity duration-300 hover:opacity-100'>
            Pricing
          </a>
        </div>

        <div className='flex items-center gap-4'>
          <a href='#' target='_blank' rel='noopener noreferrer'>
            <TwitterIcon className='size-5' />
          </a>
          <a href='#' target='_blank' rel='noopener noreferrer'>
            <svg className='size-5' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
              <path d='M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918zm4.04-.919c-.509 0-.922.412-.922.919 0 .506.414.918.922.918.508 0 .922-.412.922-.918 0-.507-.414-.919-.922-.919zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm5.636 11.29c.032.158.048.32.048.484 0 2.468-2.876 4.47-6.42 4.47-3.545 0-6.42-2.002-6.42-4.47 0-.164.017-.326.048-.484A1.614 1.614 0 0 1 4 11.862c0-.896.728-1.622 1.624-1.622.424 0 .81.167 1.096.44 1.076-.736 2.558-1.212 4.2-1.272l.848-3.986a.34.34 0 0 1 .404-.266l2.81.584c.182-.36.546-.608.97-.608.598 0 1.082.484 1.082 1.08 0 .598-.484 1.082-1.082 1.082-.592 0-1.074-.478-1.08-1.07l-2.538-.528-.76 3.584c1.618.07 3.074.548 4.132 1.278.287-.272.672-.438 1.094-.438.896 0 1.624.726 1.624 1.622 0 .572-.3 1.074-.748 1.358z' />
            </svg>
          </a>
          <a href='#' target='_blank' rel='noopener noreferrer'>
            <LinkedinIcon className='size-5' />
          </a>
        </div>
      </div>

      <Separator />

      <div className='mx-auto flex max-w-7xl justify-center px-4 py-8 sm:px-6'>
        <p className='text-center font-medium text-balance'>
          {`©${new Date().getFullYear()}`}{' '}
          <a href='#' className='hover:underline'>
            ProspectHunter
          </a>
          , Made with ❤️ for highly motivated and resourceful individuals.
        </p>
      </div>
    </footer>
  )
}

export default Footer
